import script from "./SideMenuCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuCard.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuCard.vue?vue&type=style&index=0&id=ecf67fd4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf67fd4"]])

export default __exports__